import { ActivityIndicator, useWindowDimensions } from "react-native";
import { light_black } from "../../StyleHelpers";
import styled from "styled-components/native";
import ridevueLogo from "../../assets/Logo/logos.svg";
import Image from "../../components/Image/Image";
import Toast from "../Toast";
import { globalAny } from "../../utils/Utils";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import useGenericContentStore from "../../store/genericContent.store";

const StyledContainer = styled.View`
	background-color: ${light_black};
	height: 100%;
`;

const StyledMain = styled.View`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 14.1%;
	margin-right: 14.1%;
	margin-bottom: 70px;
	border-radius: 16px;
	top: 15vh;
	overflow: hidden;
`;

const StyledButtonContainerWrapper = styled.View`
	display: flex;
	flex-direction: column;
	width: 71.8%;
	position: absolute;
	bottom: 25%;
	margin: 0 14.1% 0 14.1%;
	gap: 10px;
`;

const LandingLoader = (props: any) => {
	const windowDimensions = useWindowDimensions();
	const isAppNotSupported = useGenericContentStore((state: any) => state.isAppNotSupported);

	/**
	 * Get the localized "app not supported" message for the provided locale.
	 *
	 * Priority:
	 *  - full locale key (e.g. `app_not_supported_en-US`)
	 *  - original `languageParams` key
	 *  - primary language key (e.g. `app_not_supported_en`)
	 *  - default fallback `globalAny.language.app_not_supported`
	 */
	const getNotSupportedLanguage = () => {
		const langParam = props?.languageParams;

		if (!langParam) return globalAny.language.app_not_supported;

		const parsedLanguages = globalAny.language;

		const [language] = langParam.split("_");
		const upper = langParam.toUpperCase();

		const languageKeyDefault = `app_not_supported_${upper}`;
		const languageKeyFull = `app_not_supported_${upper.replace("_", "-")}`;
		const languageKey = `app_not_supported_${language.toUpperCase()}`;

		return (
			parsedLanguages[languageKeyFull] ??
			parsedLanguages[languageKeyDefault] ??
			parsedLanguages[languageKey] ??
			parsedLanguages.app_not_supported
		);
	};

	return (
		// @ts-ignore
		<StyledContainer>
			{/* @ts-ignore */}
			<StyledMain>
				<Image
					source={{ uri: ridevueLogo }}
					windowDimensions={windowDimensions}
					width={windowDimensions.width * 0.7}
					height={windowDimensions.height * 0.25}
					style={{ marginTop: 41, marginBottom: "16.5625vw" }}
					resizeMode="contain"
				/>
			</StyledMain>
			{!isAppNotSupported && (
				// @ts-ignore
				<StyledButtonContainerWrapper>
					<ActivityIndicator size={80} color={"white"} />
				</StyledButtonContainerWrapper>
			)}
			<Toast visible={isAppNotSupported} text={getNotSupportedLanguage()} type={ComponentTypeEnum.Processing} persist={true} />
		</StyledContainer>
	);
};

export default LandingLoader;
